import { createContext, ReactNode, useContext, useState } from 'react';
import { ForgotPasswordForm } from './forgot-password';
import { RegisterForm } from './register-form';
import { LoginForm } from './login-form';
import { AuthShell } from './auth-shell';

interface AuthContextType {
  status: string;
  toggleForm: (status: string) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [status, setStatus] = useState<string>('login');

  const toggleForm = (status: string) => {
    setStatus(status);
  };

  return <AuthContext.Provider value={{ status, toggleForm }}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function Action() {
  const { status } = useAuth();

  return (
    <AuthShell>
      {status === 'login' && <LoginForm />}
      {status === 'register' && <RegisterForm />}
      {status === 'forgot-password' && <ForgotPasswordForm />}
    </AuthShell>
  );
}
